import ThisModule from "./AcceptTerms";

export default ThisModule;
